module.exports = __webpack_public_path__ + "static/media/lock_open.6568677f.svg";